import { PUBLICATION_MENU_RULES, PUBLICATION_MENU_SEARCH } from '@/constants/publication';

interface SubMenu {
	/** 표시용 i18n 키 또는 문구 */
	title?: string;
	path?: string;
	/** 페이지 TabList state.menu 값 (미지정 시 title 사용) */
	menuKey?: string;
}
export interface MenuList {
	mainMenu: string;
	subMenu?: SubMenu[];
	mainPath?: string;
	/** mainPath 이동 시 state.menu로 전달할 값 */
	mainMenuKey?: string;
	/** i18n prefix: header.mega.{megaKey}.* */
	megaKey?: string;
	/** "홈에서 보기" 링크 경로 */
	viewPath?: string;
}

export interface MypageMenuList {
	menu: string;
	path: string;
}
export const menuList: MenuList[] = [
	{
		mainMenu: '학회소개',
		mainPath: '/introduce',
		megaKey: 'introduce',
		viewPath: '/introduce',
		subMenu: [
			{
				title: '학회소개',
				path: '/introduce',
			},
			{
				title: '학회연혁',
				path: '/introduce',
			},
			{
				title: '정관 및 규정',
				path: '/introduce',
			},
			{
				title: '임원',
				path: '/introduce',
			},
			{
				title: '분과위원회',
				path: '/introduce',
			},
			{
				title: '오시는길',
				path: '/introduce',
			},
		],
	},
	{
		mainMenu: '학회활동',
		mainPath: '/society',
		megaKey: 'society',
		viewPath: '/society',
		subMenu: [
			{
				title: '학술행사 안내',
				path: '/society',
			},
			{
				title: '초록 안내 및 등록',
				path: '/society',
			},
			{
				title: '학술대회 등록',
				path: '/society',
			},
		],
	},
	{
		mainMenu: '학회회원',
		mainPath: '/membership',
		megaKey: 'membership',
		viewPath: '/membership',
		subMenu: [
			{
				title: '가입안내',
				path: '/membership',
			},
			{
				title: '연회비 납부',
				path: '/membership',
			},
		],
	},
	{
		mainMenu: '간행물',
		mainPath: '/publication',
		megaKey: 'publication',
		viewPath: '/publication',
		subMenu: [
			{
				title: '논문검색',
				path: '/publication',
				menuKey: PUBLICATION_MENU_SEARCH,
			},
			{
				title: '논문규정',
				path: '/publication',
				menuKey: PUBLICATION_MENU_RULES,
			},

			// {
			// 	title: '게재료 결제',
			// 	path: '/publication',
			// },
		],
	},
	{
		mainMenu: '투고안내',
		mainPath: '/submission',
		megaKey: 'submission',
		viewPath: '/submission',
		subMenu: [
			{
				title: '투고안내',
				path: '/submission',
			},
		],
	},
	{
		mainMenu: '자료실',
		mainPath: '/information',
		megaKey: 'information',
		viewPath: '/information',
		subMenu: [
			{
				title: '공지사항',
				path: '/information',
			},
			{
				title: '자유게시판',
				path: '/information',
			},
		],
	},
	{
		mainMenu: '문의하기',
		mainPath: '/contact',
		megaKey: 'contact',
		viewPath: '/contact',
		subMenu: [],
	},
];

export const mypageMenuList: MypageMenuList[] = [
	{
		menu: '기본정보',
		path: '/mypage/basic',
	},
	{ menu: '직장정보', path: '/mypage/company' },
	{ menu: '학력정보', path: '/mypage/education' },
	// { menu: '재학인증', path: '/mypage/enrollment' },
	{ menu: '비밀번호 변경', path: '/mypage/password' },
	{ menu: '서비스 이용약관', path: '/mypage/term/service' },
	{ menu: '개인정보 처리방침', path: '/mypage/term/privacy' },
];

export const CONF_TITLE = '2026년 춘계 학술대회';
